import { Component, Input } from '@angular/core';
import {
  PerformanceArea,
  Measure
} from '../shared/models/performance-measures.model';


@Component({
  selector: 'app-performance-measures',
  templateUrl: './performance-measures.component.html',
  styleUrls: ['./performance-measures.component.scss'],
  standalone: false
})
export class PerformanceMeasuresComponent {
  // Presentational component: parent supplies already-fetched performanceAreas
  @Input() performanceAreas: PerformanceArea[] = [];

  // Keeping column metadata in case table styling relies on it
  displayedColumns: string[] = ['content'];

  // Simple single-row data source to satisfy mat-table binding requirements
  dataSource: any[] = [{ data: 'performance-measures' }];

  toggleArea(areaIndex: number): void {
    this.performanceAreas[areaIndex].expanded =
      !this.performanceAreas[areaIndex].expanded;
  }

  toggleMeasure(areaIndex: number, measureIndex: number): void {
    this.performanceAreas[areaIndex].measures[measureIndex].expanded =
      !this.performanceAreas[areaIndex].measures[measureIndex].expanded;
  }

  getTotalMeasures(area: PerformanceArea): number {
    return area.measures.length;
  }

  // trackBy functions to optimize *ngFor rendering
  trackMeasure(index: number, measure: Measure): string {
    // measureNumber is a serial display number, so index is safest stable key
    return index.toString();
  }
}